export default function listBlock(count, layout) {
  return {
    list_result_count: count.toString(),
    list_layout: layout || ''
  };
};
